<template>
  <div class="home">
    <navbar />
    <div class="main-container">
      <topNavbar />
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import navbar from "@/components/navbar/index.vue";
import topNavbar from "@/components/topNavbar/index.vue";

export default {
  name: "Home",
  components: {
    navbar,
    topNavbar
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    }
  },
  created() {
    if (this.$route.name == "wrap") {
      this.$router.push("/selfData");
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100%;
}
.content {
  margin: 20px;
}

.main-container {
  margin-left: 220px;
  transition: 1s ease-in-out;
}
@media (max-width: 992px) {
  .main-container {
    margin-left: 10px;
  }
}
</style>
